import { Controller } from 'stimulus';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';

export default class ResourceMoreInfoController extends Controller {
  sendAnalytics() {
    triggerCustomEvent(events.show_page.more_info, {
      resourceContentType: this.data.get('contentType'),
    });
  }
}
